import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Avatar,
  Box,
  Grid,
  Link,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import jwt_decode from "jwt-decode";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import { getDeviceCommands } from "../../slices/Reports/DeviceCMDandOperationLogsSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import FilterDeviceCommand from "./FilterDeviceCommand";

export default function DeviceCommands() {
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const { darkMode } = useContext(ThemeContext);

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    commandId: "",
    deviceModel: "",
    deviceSn: "",
    content: "",
    remark: "",
    returnedValue: "",
    submitTimeFrom: "",
    submitTimeTo: "",
    returnFrom: "",
    returnTo: "",
  });

  const defaultPaging = {
    page: 1,
    rowsPerPage: 10,
  };

  const defaultFilter = {
    commandId: "",
    deviceModel: "",
    deviceSn: "",
    content: "",
    remark: "",
    returnedValue: "",
    submitTimeFrom: "",
    submitTimeTo: "",
    returnFrom: "",
    returnTo: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
    setRowsPerPage(size);
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getDeviceCommands(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "DMSI0000" && data.data) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.deviceCommands);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      commandId: data.commandId,
      deviceSn: data.deviceSn,
      deviceModel: data.deviceModel,
      content: data.content,
      submitTimeFrom: data.submitTimeFrom,
      submitTimeTo: data.submitTimeFrom,
      remark: data.remark,
    });
  };
  const getStatusStyles = (status) => {
    switch (status) {
      case "open":
        return { color: "#0073e6", backgroundColor: "#e6f4ff" };
      case "closed":
        return { color: "#b30000", backgroundColor: "#ffe6e6" };
      case "collected":
        return { color: "#b30000", backgroundColor: "#ffe6e6" };
      default:
        return null;
    }
  };

  const StatusTab = ({ status }) => {
    const styles = getStatusStyles(status);
    if (!styles) {
      return null;
    }
    return (
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Grid style={{ flex: "0 0 75px" }}>
          <Typography style={{ ...styles, padding: "4px" }}>
            {status === "open"
              ? "Open"
              : status === "closed"
                ? "Closed"
                : status === "collected"
                  ? "Collected"
                  : ""}
          </Typography>
        </Grid>
      </Box>
    );
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      case "DD-MM-YYYY":
        return "dd-MM-yyyy HH:mm";
      case "MM-DD-YYYY":
        return "MM-dd-yyyy HH:mm";
      case "YYYY-MM-DD":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const renderCellCreatedAt = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.createdAt)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm:ss"
        : date === "MM-dd-yyyy HH:mm"
          ? "MM-DD-YYYY HH:mm:ss"
          : date === "yyyy-MM-dd HH:mm"
            ? "YYYY-MM-DD HH:mm:ss"
            : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const renderCellUpdatedAt = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.updatedAt)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm:ss"
        : date === "MM-dd-yyyy HH:mm"
          ? "MM-DD-YYYY HH:mm:ss"
          : date === "yyyy-MM-dd HH:mm"
            ? "YYYY-MM-DD HH:mm:ss"
            : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 65) {
      return text.substring(0, 65) + "...";
    } else {
      return text;
    }
  };

  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 700,
      backgroundColor: "white",
      color: "black",
      border: "0.7px solid black",
      borderRadius: "0px !important",
      height: "auto",
      maxHeight: "150px",
      overflow: "auto",
      opacity: 0.9, // Slightly more readable
      "&::-webkit-scrollbar": {
        width: "5px",
        height: "5px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: darkMode ? "#4D6070" : "#d9d9d9",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
      },
    },
  }));

  const handleTextOverflowOperationDetails = (text) => {
    if (text && text.length > 30) {
      return text.substring(0, 30) + "...";
    } else {
      return text;
    }
  };

  const ZoomHandaler = (params) => (
    <SimpleDialogDemo
      button={
        <Avatar
          alt={params.row.personImageObjectKey}
          src={
            params.row.personImageObjectKey !== undefined
              ? params.row.personImageObjectKey
              : null
          }
        ></Avatar>
      }
      child={
        <Avatar
          style={{
            width: "300px",
            height: "300px",
            border: "1px solid #FFFF",
            fontSize: "100px",
            borderRadius: "50%",
          }}
          alt={params.row.personImageObjectKey}
          src={
            params.row.personImageObjectKey !== undefined
              ? params.row.personImageObjectKey
              : null
          }
        ></Avatar>
      }
    />
  );
  const handleCmdResponseCode = (code) => {
    if (code == null) return "-";
    return code >= 0
      ? CommonUtil.cmdResponseCode["0"]
      : CommonUtil.cmdResponseCode[code] || code;
  };

  const columns = React.useMemo(
    () => [
      {
        field: " ",
        headerName: " ",
        sortable: false,
        width: 10,
        minWidth: 10,
      },
      {
        field: "commandId",
        headerName: t("REPORT0026"),
        flex: 1,
        minWidth: 100,
      },
      { field: "deviceSn", headerName: t("DEVI0060"), flex: 1, minWidth: 150 },
      {
        field: "deviceModel",
        headerName: t("DEVI0005"),
        flex: 1,
        minWidth: 150,
      },

      {
        field: "content",
        headerName: t("REPORT0027"),
        flex: 1,
        minWidth: 500,
        valueGetter: (params) => params.row.content,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.content}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.content)}</span>
          </Tooltip>
        ),
      },

      {
        field: "priority",
        headerName: t("REPORT0059"),
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          return (
            <div
              style={{
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
                height: "100%",
              }}
            >
              {params.row.priority === "1" ? (
                <CheckIcon sx={{ color: "green" }} />
              ) : (
                <CloseIcon sx={{ color: "red" }} />
              )}
            </div>
          );
        },
      },
      {
        field: "createdAt",
        headerName: t("REPORT0033"),
        flex: 1,
        minWidth: 190,
        renderCell: renderCellCreatedAt(formatDate(companySettings.dateFormat)),
      },
      {
        field: "updatedAt",
        headerName: t("REPORT0034"),
        flex: 1,
        minWidth: 190,
        renderCell: renderCellUpdatedAt(formatDate(companySettings.dateFormat)),
      },

      {
        field: "cmdResponseCode",
        headerName: t("REPORT0035"),
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          const code = params.row?.cmdResponseCode;
          const responseText = handleCmdResponseCode(code);
          const color = code != null && code >= 0 ? "green" : "red";

          return (
            <CustomWidthTooltip title={responseText}>
              <div>
                {code != null ? <b style={{ color }}>{responseText}</b> : "-"}
              </div>
            </CustomWidthTooltip>
          );
        },
      },
      {
        field: "cmdResponseMsg",
        headerName: t("REPORT0036"),
        flex: 1,
        minWidth: 150,
      },
    ],
    []
  );

  return (
    <>
      <HeaderToolbar title={t("DEVICECMD")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{ gap: "6px", padding: "10px 0px 10px 10px" }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>

        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>

        <Box item>
          <FilterDeviceCommand
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
            date={formatDate(companySettings.dateFormat)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
    </>
  );
}
